import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../firebase/config';

export const storageService = {
  // Загрузить файл в Firebase Storage
  async uploadFile(file, path) {
    try {
      const storageRef = ref(storage, path);
      const snapshot = await uploadBytes(storageRef, file);
      const downloadURL = await getDownloadURL(snapshot.ref);
      return downloadURL;
    } catch (error) {
      console.error('Error uploading file:', error);
      throw error;
    }
  },

  // Загрузить иконку документа
  async uploadDocumentIcon(file, documentId) {
    const timestamp = Date.now();
    const fileName = `document_icons/${documentId}_${timestamp}_${file.name}`;
    return await this.uploadFile(file, fileName);
  },

  // Загрузить PDF файл документа
  async uploadDocumentFile(file, documentId) {
    const timestamp = Date.now();
    const fileName = `documents/${documentId}_${timestamp}_${file.name}`;
    return await this.uploadFile(file, fileName);
  },

  // Загрузить изображение статьи
  async uploadArticleImage(file, articleId) {
    const timestamp = Date.now();
    const fileName = `article_images/${articleId}_${timestamp}_${file.name}`;
    return await this.uploadFile(file, fileName);
  }
};


